/**
 * Mirrors the backend `ChargeExportDateFormat`. The API serialises enums as strings, so these are
 * the names, not ordinals — an ordinal never matches what a saved template answers with.
 */
export const DATE_FORMAT = {
  iso: 'Iso',
  us: 'Us'
};
export const SCOPE = {
  property: 'property',
  account: 'account'
};

/**
 * The header a column will actually export under: the custom one, falling back to the field's label
 * exactly as the server does, so the preview cannot disagree with the file.
 */
export const headerFor = (column, fieldsById) => {
  var _column$customHeader, _fieldsById$get$label, _fieldsById$get;
  const custom = ((_column$customHeader = column.customHeader) !== null && _column$customHeader !== void 0 ? _column$customHeader : '').trim();
  if (custom) return custom;
  return (_fieldsById$get$label = (_fieldsById$get = fieldsById.get(column.livableField)) === null || _fieldsById$get === void 0 ? void 0 : _fieldsById$get.label) !== null && _fieldsById$get$label !== void 0 ? _fieldsById$get$label : column.livableField;
};
export const headersOf = (columns, fieldsById) => columns.map(column => headerFor(column, fieldsById));

/**
 * Headers used more than once, compared case-insensitively — a PMS import matches on the header, so
 * two columns called `Amount` and `amount` are the same collision.
 */
export const duplicateHeadersOf = headers => {
  const seen = new Set();
  const duplicates = new Set();
  headers.forEach(header => {
    const key = header.toLowerCase();
    if (seen.has(key)) duplicates.add(header);
    seen.add(key);
  });
  return [...duplicates];
};

/** 'Account' or the property's own scope, for the badge in the template list. */
export const scopeLabel = template => template.propertyId ? 'This property' : 'All properties';